import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReallocationSource, ReallocationTarget } from '../../../types/reallocation/Reallocation'
import { deleteReallocationTarget } from '../service/reallocationService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import reallocationQueryKeys from './reallocationQueryKeys'
import invalidateReportQueries from './invalidateReportQueries'

interface DeleteReallocationTargetVariables {
  target: ReallocationTarget
  source: ReallocationSource
}

export const useDeleteReallocationTarget = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ target, source }: DeleteReallocationTargetVariables) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      await deleteReallocationTarget(companyId, source.id, target.id)
      return { target, source }
    },
    onSuccess: ({ target, source }) => {
      queryClient.setQueryData<ReallocationSource[]>(reallocationQueryKeys.list({ companyId }), old => {
        if (!Array.isArray(old)) return old
        return old.map(item =>
          item.id === source.id ? { ...item, targets: item.targets.filter(t => t.id !== target.id) } : item
        )
      })
      invalidateReportQueries(queryClient)
    },
    onError: error => {
      console.error('Failed to delete reallocation target:', error)
    }
  })
}
